import auto_scheduling from "./auto_scheduling";
import click_drag from "./click_drag";
import critical_path from "./critical_path";
import drag_timeline from "./drag_timeline";
import export_api from "./export_api";
import fullscreen from "./fullscreen";
import grouping from "./grouping";
import keyboard_navigation from "./keyboard_navigation";
import marker from "./marker";
import multiselect from "./multiselect";
import overlay from "./overlay";
import quick_info from "./quick_info";
import tooltip from "./tooltip";
import undo from "./undo";

export default {
	auto_scheduling,
	click_drag,
	critical_path,
	drag_timeline,
	fullscreen,
	keyboard_navigation,
	quick_info,
	tooltip,
	undo,
	grouping,
	marker,
	multiselect,
	overlay,
	export_api
};